import { ActionType } from '../../../components/modals/v2/connectors/helpers';

export const GoogleCloudSecurityCommandCenterSchema = {
  name: 'GSC Connector',
  steps: {
    0: {
      name: 'Step 1',
      elements: [
        {
          type: 'description',
          description:
            'To connect to Google Cloud Security Command Center, you will need a Google Cloud Service Account.',
          column: 0,
        },
        {
          type: 'description',
          description:
            'Once you have created the Google Cloud Service Account, you can finish adding the Google connector in the Cowbell Platform.',
          column: 1,
        },
      ],
      layout: {
        columns: 2,
        containerProps: { spacing: 2, direction: 'row' },
        columnProps: {
          0: { xs: 12, md: 12 },
          1: { xs: 12, md: 12 },
        },
        elementContainerProps: { 0: {}, 1: {} },
      },
      action: {
        type: ActionType.GO_FORWARD,
      },
    },
    1: {
      name: 'Step 2',
      elements: [
        {
          name: 'orgIdText',
          type: 'description',
          description:
            'To finish adding the connector we would need your Google Cloud organization ID.',
          column: 0,
        },
        {
          name: 'orgId',
          label: 'Google Cloud organization ID',
          description: 'Please enter your Google Cloud organization ID',
          type: 'text',
          required: true,
          column: 1,
        },
        {
          name: 'apiKeyText',
          description: 'Upload Service Account API Key',
          type: 'description',
          column: 2,
          elementProps: { type: 'body1', align: 'center' },
        },
        {
          name: 'credentials',
          label: 'Upload Service Center API Key',
          description:
            'The API key is a JSON file that you downloaded from Google Workspace',
          type: 'upload',
          elementProps: { accept: ['application/json'] },
          required: true,
          column: 3,
        },
      ],
      layout: {
        columns: 4,
        containerProps: { spacing: 2, direction: 'row' },
        columnProps: {
          0: { xs: 12, md: 12 },
          1: { xs: 12, md: 12 },
          2: { xs: 12, md: 12 },
          3: { xs: 12, md: 12 },
        },
        elementContainerProps: { 0: {}, 1: {}, 2: {}, 3: {} },
      },
      action: {
        type: ActionType.API_ENDPOINT,
        requestConfig: {
          url: '/api/connector/v1/gsc/add',
          method: 'POST',
        },
      },
    },
    2: {
      name: 'Step 3',
      elements: [
        {
          type: 'description',
          description:
            'The Google Service Account API key has been successfully uploaded.',
          column: 0,
        },
        {
          type: 'description',
          description:
            'A Google connector has been added for your organization.',
          column: 1,
        },
      ],
      layout: {
        columns: 2,
        containerProps: { spacing: 2, direction: 'row' },
        columnProps: {
          0: { xs: 12, md: 12 },
          1: {
            xs: 12,
            md: 12,
          },
        },
        elementContainerProps: { 0: {}, 1: {} },
      },
      action: {
        type: ActionType.CLOSE_MODAL,
      },
    },
  },
};
